import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import { ICON_SIZES } from '../../../constants/constant';
import TAGTypography from '../TAGTypography/TAGTypography';

var TAGNavListItem = function TAGNavListItem(_ref) {
  var divider = _ref.divider,
      _onClick = _ref.onClick,
      onCloseDrawer = _ref.onCloseDrawer,
      primaryText = _ref.primaryText,
      selected = _ref.selected,
      selectItemHandler = _ref.selectItemHandler,
      svgName = _ref.svgName;
  return React.createElement(ListItem, {
    button: true,
    selected: selected,
    onClick: function onClick() {
      selectItemHandler && selectItemHandler();
      onCloseDrawer && onCloseDrawer();
      _onClick && _onClick();
    },
    divider: divider,
    sx: {
      overflow: 'auto',
      color: selected ? 'secondary.main' : 'text.primary',
      '&:hover': {
        borderRadius: '4px'
      },
      '&.Mui-selected': {
        borderRadius: '4px',
        backgroundColor: 'secondary.light',
        '&.Mui-selected:hover': {
          backgroundColor: 'secondary.light'
        }
      }
    }
  }, svgName && React.createElement(ListItemIcon, {
    sx: {
      color: 'inherit'
    }
  }, React.createElement(TAGSvgIcon, {
    icon: svgName,
    size: ICON_SIZES.md,
    color: 'inherit'
  })), React.createElement(ListItemText, {
    disableTypography: true,
    primary: primaryText && React.createElement(TAGTypography, {
      variant: "bodyMediumBook"
    }, primaryText),
    primaryTypographyProps: {
      color: 'text.primary'
    }
  }));
};

export default TAGNavListItem;